(function(root, factory) {
  var launchApi = root && root.DYOFLaunchContract;
  var coverApi = root && root.DYOFCoverContract;
  var printableApi = root && root.DYOFPrintableText;
  if (!launchApi && typeof module === "object" && module.exports) {
    launchApi = require("./dyof-launch-contract.js");
  }
  if (!coverApi && typeof module === "object" && module.exports) {
    coverApi = require("./dyof-cover-contract.js");
  }
  if (!printableApi && typeof module === "object" && module.exports) {
    printableApi = require("./dyof-printable-text.js");
  }
  var api = factory(
    launchApi,
    coverApi,
    printableApi,
    root
  );

  if (root) {
    root.DYOFState = api;
  }

  if (typeof module === "object" && module.exports) {
    module.exports = api;
  }
})(typeof globalThis !== "undefined" ? globalThis : this, function(contract, coverContract, printableText, root) {
  "use strict";

  // Translations (assets/dyof-i18n.js, non-English stores only). The English
  // stays here and is used as is when no language pack is loaded.
  function dyofInterpolate(text, params) {
    return params ? String(text).replace(/\{([A-Za-z0-9_]+)\}/g, function(match, name) {
      return Object.prototype.hasOwnProperty.call(params, name) && params[name] != null ? String(params[name]) : match;
    }) : text;
  }
  function dyofT(key, english, params) {
    var i18n = root.DYOFI18n;
    return i18n ? i18n.t(key, english, params) : dyofInterpolate(english, params);
  }
  function dyofPlural(key, count, english, params) {
    var i18n = root.DYOFI18n;
    var values = Object.assign({ count: count }, params || {});
    return i18n ? i18n.plural(key, count, english, params) : dyofInterpolate(Number(count) === 1 ? english.one : english.other, values);
  }

  var SCHEMA_VERSION = 3;
  var STEPS = ["design", "layout", "personalise", "review"];
  var PRODUCT_TYPES = ["refill", "clipbook", "planner"];
  var LIFESTYLES = ["classic", "modern", "neutral", "playful"];
  var SCREEN_DEFINITIONS = {
    "cover-selection": { phase: "design", preview: "sizes", renderer: "static", title: dyofT("state.preview.review_sizes", "Review sizes") },
    "front-cover": { phase: "design", preview: "closed-cover", renderer: "client", title: dyofT("state.preview.front_cover", "Front cover preview") },
    "back-cover": { phase: "design", preview: "closed-cover", renderer: "client", title: dyofT("state.preview.back_cover", "Back cover preview") },
    "refill-type": { phase: "layout", preview: "blank-open", renderer: "static", title: dyofT("state.preview.refill_design", "Refill design") },
    "dated-layout": { phase: "layout", preview: "open-spread", renderer: "server", title: dyofT("state.preview.live_page", "Live page preview") },
    "undated-layout": { phase: "layout", preview: "open-spread", renderer: "cached-pdf", title: dyofT("state.preview.undated_refill", "Undated refill preview") },
    "planner-details": { phase: "personalise", preview: "front-sheet", renderer: "client", title: dyofT("state.preview.first_page", "Instant first-page preview") },
    "personal-dates": { phase: "personalise", preview: "personal-dates", renderer: "static", title: dyofT("state.preview.personal_dates", "Personal dates preview") },
    review: { phase: "review", preview: "review", renderer: "client", title: dyofT("state.preview.planner_review", "Your planner review") }
  };
  var DEPENDENCY_RESET_MATRIX = {
    NAVIGATE_SCREEN: {
      canonical: [],
      normalize: [],
      invalidatesPreview: false
    },
    NAVIGATE_STEP: {
      canonical: [],
      normalize: [],
      invalidatesPreview: false
    },
    SET_PRODUCT_TYPE: {
      canonical: ["cover.background when product type changes"],
      normalize: ["selection.size", "selection.engine", "selection.style", "selection.layout"],
      invalidatesPreview: true
    },
    SET_REFILL_TYPE: {
      canonical: [],
      normalize: ["selection.size", "selection.engine", "selection.variant"],
      invalidatesPreview: true
    },
    SET_UNDATED_FILL: {
      canonical: [],
      normalize: [],
      invalidatesPreview: true
    },
    SET_SELECTION: {
      canonical: [],
      normalize: [
        "engine/style compatibility",
        "size/layout compatibility",
        "layout controls only when unsupported",
        "lineStyle notes/appointmentTimes compatibility",
        "modern view/design/date-position/start-day compatibility"
      ],
      preserves: ["firstPage", "features", "cover", "compatible calendar", "compatible dates"],
      invalidatesPreview: true
    },
    SET_FIRST_PAGE: {
      canonical: [],
      normalize: ["firstPage field bounds"],
      preserves: ["journey", "selection", "cover", "features"],
      invalidatesPreview: true
    },
    SET_FEATURES: {
      canonical: [],
      normalize: ["feature field bounds"],
      preserves: ["journey", "selection", "firstPage", "cover"],
      invalidatesPreview: true
    },
    SET_COVER: {
      canonical: [],
      normalize: ["cover object bounds"],
      preserves: ["journey", "selection", "firstPage", "features"],
      invalidatesPreview: true
    },
    SET_COVER_SIZE: {
      canonical: ["cover.background when size changes"],
      normalize: ["selection.engine", "selection.style", "selection.layout", "undated size compatibility"],
      preserves: ["firstPage", "features", "compatible cover objects"],
      invalidatesPreview: true
    },
    COVER_ACTION: {
      canonical: [],
      normalize: ["cover object bounds"],
      preserves: ["journey", "selection", "firstPage", "features"],
      invalidatesPreview: true
    }
  };

  var CONFIG_ACTIONS = Object.keys(DEPENDENCY_RESET_MATRIX).reduce(function(result, actionType) {
    if (actionType !== "COVER_ACTION" && DEPENDENCY_RESET_MATRIX[actionType].invalidatesPreview) {
      result[actionType] = true;
    }
    return result;
  }, {});

  function own(object, key) {
    return Object.prototype.hasOwnProperty.call(object, key);
  }

  function isObject(value) {
    return value && typeof value === "object" && !Array.isArray(value);
  }

  function clone(value) {
    var result;
    var key;

    if (Array.isArray(value)) {
      return value.map(clone);
    }

    if (!isObject(value)) {
      return value;
    }

    result = {};
    for (key in value) {
      if (own(value, key)) {
        result[key] = clone(value[key]);
      }
    }
    return result;
  }

  function merge(base, patch) {
    var result = clone(base || {});
    var key;

    if (!isObject(patch)) {
      return result;
    }

    for (key in patch) {
      if (!own(patch, key)) {
        continue;
      }
      result[key] = isObject(result[key]) && isObject(patch[key])
        ? merge(result[key], patch[key])
        : clone(patch[key]);
    }

    return result;
  }

  function firstKey(object) {
    var keys = Object.keys(object || {});
    return keys.length ? keys[0] : "";
  }

  function firstModernStyleKey() {
    var styles = contract && contract.styles ? contract.styles : {};
    var keys = Object.keys(styles);
    var index;

    for (index = 0; index < keys.length; index += 1) {
      if (styles[keys[index]] && styles[keys[index]].engine === "modern") {
        return keys[index];
      }
    }

    return "gradient";
  }

  function firstLegacyStyleKey() {
    var styles = contract && contract.styles ? contract.styles : {};
    var keys = Object.keys(styles);
    var index;

    for (index = 0; index < keys.length; index += 1) {
      if (styles[keys[index]] && styles[keys[index]].engine === "legacy") {
        return keys[index];
      }
    }

    return "minimal";
  }

  function currentStartMonth() {
    var now = new Date();
    return now.getFullYear() + "-" + String(now.getMonth() + 1).padStart(2, "0");
  }

  function normalizeProductType(value) {
    return PRODUCT_TYPES.indexOf(value) !== -1 ? value : "refill";
  }

  function datedLayoutError(state) {
    if (state.journey.refillType === "dated"
      && contract && contract.isDatedLayoutSupported
      && !contract.isDatedLayoutSupported(state.selection, state.journey.productType)) {
      return dyofT("state.layout.planner_daily", "Daily is not available for Planner & Notebook. Choose a different layout.");
    }
    return "";
  }

  function getStepDescriptors(stateInput) {
    var source = stateInput || {};
    var journey = source.journey || {};
    var productType = normalizeProductType(journey.productType);

    if (productType === "refill") {
      return [
        { id: "layout", label: dyofT("state.step.layout", "Layout"), screens: ["dated-layout"] },
        { id: "personalise", label: dyofT("state.step.personalise", "Personalise"), screens: ["planner-details", "personal-dates"] }
      ];
    }

    return [
      { id: "design", label: dyofT("state.step.design", "Design"), screens: ["cover-selection", "front-cover", "back-cover"] },
      { id: "layout", label: dyofT("state.step.layout", "Layout"), screens: ["refill-type", "dated-layout", "undated-layout"] },
      { id: "personalise", label: dyofT("state.step.personalise", "Personalise"), screens: ["planner-details", "personal-dates"] }
    ];
  }

  function getScreenStep(stateInput, screenInput) {
    var screen = screenInput || stateInput && stateInput.screen;
    var descriptors;
    var index;

    if (screen === "review") {
      return "review";
    }

    descriptors = getStepDescriptors(stateInput);
    for (index = 0; index < descriptors.length; index += 1) {
      if (descriptors[index].screens.indexOf(screen) !== -1) {
        return descriptors[index].id;
      }
    }

    return getScreenPhase(screen);
  }

  function getRoute(stateInput) {
    var source = stateInput || {};
    var journey = source.journey || {};
    var productType = normalizeProductType(journey.productType);
    var refillType = journey.refillType === "undated"
      ? "undated"
      : journey.refillType === "none" && productType === "clipbook" ? "none" : "dated";
    var route = [];

    if (productType === "clipbook" || productType === "planner") {
      route.push("cover-selection", "front-cover", "back-cover");
    } else {
      return ["dated-layout", "planner-details", "personal-dates", "review"];
    }

    route.push("refill-type");
    // A Clipbook cover on its own ("none") goes from Refill straight to Review.
    if (refillType === "undated") {
      route.push("undated-layout");
    } else if (refillType === "dated") {
      route.push("dated-layout", "planner-details", "personal-dates");
    }
    route.push("review");
    return route;
  }

  function getScreenPhase(screen) {
    return SCREEN_DEFINITIONS[screen]
      ? SCREEN_DEFINITIONS[screen].phase
      : "layout";
  }

  function getPreviewDescriptor(stateInput) {
    var state = normalizeState(stateInput);
    var definition = SCREEN_DEFINITIONS[state.screen] || SCREEN_DEFINITIONS["refill-type"];
    var product = state.journey.productType === "planner"
      ? "notebook"
      : state.journey.productType === "refill" ? "organiser" : "clipbook";
    return {
      screen: state.screen,
      phase: getScreenStep(state, state.screen),
      mode: definition.preview,
      title: state.screen === "cover-selection" && state.journey.productType === "planner"
        ? dyofT("state.preview.planner_cover", "A5 Planner cover")
        : definition.title,
      productType: state.journey.productType,
      product: product,
      size: state.selection.size,
      lifestyle: state.journey.lifestyle,
      contentKey: state.screen === "undated-layout"
        ? state.journey.undatedFill
        : state.screen === "dated-layout"
          ? state.selection.engine === "legacy"
            ? [state.selection.style, state.selection.layout, state.selection.lineStyle].join(":")
            : state.selection.variant
          : null,
      requestVersion: state.revision,
      renderer: definition.renderer
    };
  }

  // The store's own moon time zone (London unless a store profile says otherwise).
  function defaultMoonTimezoneOffset() {
    var controls = contract && contract.controls ? contract.controls : {};
    return typeof controls.defaultMoonTimezoneOffset === "number" ? controls.defaultMoonTimezoneOffset : 0;
  }

  function createDefaultState() {
    return {
      schemaVersion: SCHEMA_VERSION,
      contractVersion: contract && contract.version ? contract.version : "unknown",
      revision: 0,
      step: "layout",
      screen: "refill-type",
      journey: {
        productType: "refill",
        lifestyle: "classic",
        refillType: "dated",
        undatedFill: "mix"
      },
      selection: {
        engine: "modern",
        size: "a5",
        language: "en",
        style: "gradient",
        colourMode: "signature-multicolour",
        singleColour: null,
        paperColour: "white",
        layout: "weekly",
        lineStyle: "blank",
        calendar: false,
        notes: false,
        appointmentTimes: false,
        layoutView: "standard",
        dayDesign: "plain",
        variant: "weekly.standard.plain.a5",
        fallbackVariant: "weekly.standard.ruled.a5",
        datePosition: "left-aligned",
        headerTheme: "productivity",
        startMonth: currentStartMonth(),
        startDay: "monday",
        documentLengthMonths: 12
      },
      firstPage: {
        line1: "",
        line2: "",
        line3: "",
        textColor: "#FFFFFF",
        backgroundColor: "#C8A3CD"
      },
      cover: coverContract && coverContract.createDefaultCover
        ? coverContract.createDefaultCover()
        : {},
      features: {
        birthdays: [],
        events: [],
        activities: [],
        holidays: [],
        countryHolidays: {
          enabled: false,
          groups: []
        },
        religiousHolidays: {
          enabled: false,
          groups: []
        },
        personalDates: [],
        moonPhases: {
          enabled: false,
          timezoneOffset: defaultMoonTimezoneOffset()
        }
      },
      preview: {
        status: "idle",
        requestKey: null,
        pages: [],
        error: null
      },
      save: {
        status: "idle",
        snapshotId: null,
        error: null
      }
    };
  }

  function normalizeModernSelection(input) {
    var result = clone(input);
    var styles = contract && contract.styles ? contract.styles : {};
    var style = own(styles, result.style) ? styles[result.style] : null;
    var styleKey = style && style.engine === "modern"
      ? result.style
      : firstModernStyleKey();
    var layouts = contract && contract.modernVariants ? contract.modernVariants : {};
    var layoutKey = own(layouts, result.layout) ? result.layout : firstKey(layouts);
    var layout = layouts[layoutKey] || { views: {} };
    var viewKey = own(layout.views, result.layoutView) ? result.layoutView : firstKey(layout.views);
    var view = layout.views[viewKey] || { designs: {}, supportedStartDays: ["monday"] };
    var designKey = own(view.designs, result.dayDesign)
      ? result.dayDesign
      : firstKey(view.designs);
    var startDays = view.supportedStartDays || ["monday"];
    var controls = contract && contract.controls ? contract.controls : {};
    var colourModes = controls.colourModes || [];
    var paperColours = controls.paperColours || [];
    var headerThemes = contract && contract.controls
      ? contract.controls.headerThemes || []
      : [];
    var languages = controls.languages || [];
    var singleColours = contract && contract.getSingleColours
      ? contract.getSingleColours(styleKey)
      : [];
    var singleColourValues = singleColours.map(function(option) {
      return option.value;
    });
    var datePositions;

    result.engine = "modern";
    result.size = "a5";
    result.style = styleKey;
    result.layout = layoutKey;
    result.layoutView = viewKey;
    result.dayDesign = designKey;
    result.variant = view.designs[designKey];
    result.startDay = startDays.indexOf(result.startDay) !== -1
      ? result.startDay
      : startDays[0];

    datePositions = contract && contract.getSupportedDatePositions
      ? contract.getSupportedDatePositions(result)
      : ["left-aligned"];
    result.datePosition = datePositions.indexOf(result.datePosition) !== -1
      ? result.datePosition
      : datePositions[0];
    result.headerTheme = headerThemes.indexOf(result.headerTheme) !== -1
      ? result.headerTheme
      : headerThemes[0] || "productivity";
    result.colourMode = colourModes.indexOf(result.colourMode) !== -1
      ? result.colourMode
      : "signature-multicolour";
    result.paperColour = paperColours.indexOf(result.paperColour) !== -1
      ? result.paperColour
      : "white";
    result.language = languages.indexOf(result.language) !== -1
      ? result.language
      : defaultLanguage(languages);
    result.startMonth = /^\d{4}-(0[1-9]|1[0-2])$/.test(result.startMonth)
      ? result.startMonth
      : currentStartMonth();

    if (result.colourMode === "signature-multicolour") {
      result.singleColour = null;
    } else if (singleColourValues.indexOf(result.singleColour) === -1) {
      result.singleColour = singleColourValues[0] || "colour-01";
    }

    return result;
  }

  function normalizeLegacySelection(input) {
    var result = clone(input);
    var styles = contract && contract.styles ? contract.styles : {};
    var style = own(styles, result.style) ? styles[result.style] : null;
    var layouts = contract && contract.legacyVariants ? contract.legacyVariants : {};
    var supportedLayouts = contract && contract.getSupportedLegacyLayouts
      ? contract.getSupportedLegacyLayouts(result.size)
      : Object.keys(layouts);
    var layoutKey = own(layouts, result.layout) && supportedLayouts.indexOf(result.layout) !== -1
      ? result.layout
      : supportedLayouts[0] || firstKey(layouts) || "daily";
    var layout = layouts[layoutKey] || { controls: [] };
    var controls = layout.controls || [];
    var languages = contract && contract.controls ? contract.controls.languages || [] : [];

    result.engine = "legacy";
    result.style = style && style.engine === "legacy" ? result.style : firstLegacyStyleKey();
    result.layout = layoutKey;
    result.paperColour = result.style === "luxury" ? "cream" : "white";
    result.lineStyle = result.lineStyle === "ruled" ? "ruled" : "blank";
    result.calendar = controls.indexOf("calendar") !== -1 && Boolean(result.calendar);
    result.notes = controls.indexOf("notes") !== -1
      && result.lineStyle === "blank"
      && Boolean(result.notes);
    result.appointmentTimes = controls.indexOf("appointmentTimes") !== -1
      && result.lineStyle === "ruled"
      && Boolean(result.appointmentTimes);
    if (controls.indexOf("lineStyle") === -1) {
      result.lineStyle = "blank";
    }
    result.startDay = result.startDay === "sunday" ? "sunday" : "monday";
    result.language = languages.indexOf(result.language) !== -1 ? result.language : defaultLanguage(languages);
    result.startMonth = /^\d{4}-(0[1-9]|1[0-2])$/.test(result.startMonth)
      ? result.startMonth
      : currentStartMonth();
    result.documentLengthMonths = 12;
    result.variant = null;
    return result;
  }

  function normalizeSelection(input, refillType, productType) {
    var result = clone(input);
    var style = contract && contract.getStyle ? contract.getStyle(result.style) : null;
    var supportsA4 = productType === "refill" && refillType === "dated";

    result.size = productType === "planner"
      ? "a5"
      : result.size === "personal"
        ? "personal"
        : result.size === "a4" && supportsA4
          ? "a4"
          : "a5";

    if (refillType === "undated" || refillType === "none") {
      result.engine = "predefined";
      result.variant = null;
      return result;
    }

    if (result.size === "personal" || result.size === "a4") {
      if (!style || style.engine !== "legacy") {
        result.style = firstLegacyStyleKey();
      }
      return normalizeLegacySelection(result);
    }

    if (style && style.engine === "legacy") {
      return normalizeLegacySelection(result);
    }

    return normalizeModernSelection(result);
  }

  function normalizeStringList(values, allowedValues) {
    var allowed = allowedValues || [];
    var seen = {};

    return (Array.isArray(values) ? values : []).filter(function(value) {
      var key = String(value || "");
      if (!key || allowed.indexOf(key) === -1 || seen[key]) {
        return false;
      }
      seen[key] = true;
      return true;
    }).map(String);
  }

  function normalizeFirstPage(input, selection) {
    var source = isObject(input) ? input : {};
    var controls = contract && contract.controls ? contract.controls : {};
    var colours = controls.firstPageColours || [];
    var minimalColours = controls.minimalFirstPageColours
      ? controls.minimalFirstPageColours
      : ["#666666"];
    var isMinimal = selection && selection.style === "minimal";
    var allowedColours = isMinimal
      ? minimalColours
      : [];
    var textColor = String(source.textColor || "").toUpperCase();
    var backgroundColor = String(source.backgroundColor || "#E0B3CF").toUpperCase();
    if (!isMinimal) {
      allowedColours = colours;
    }

    return {
      line1: String(source.line1 || "").slice(0, 28),
      line2: String(source.line2 || "").slice(0, 28),
      line3: String(source.line3 || "").slice(0, 28),
      textColor: allowedColours.indexOf(textColor) !== -1
        ? textColor
        : isMinimal
          ? "#666666"
          : allowedColours[0] || "#FFFFFF",
      backgroundColor: /^#[0-9A-F]{6}$/.test(backgroundColor)
        ? backgroundColor
        : "#E0B3CF"
    };
  }

  function normalizePersonalDates(values) {
    var colours = contract && contract.controls
      ? contract.controls.personalisationColours || []
      : [];
    var frequencies = contract && contract.controls
      ? contract.controls.personalDateFrequencies || []
      : [];

    return (Array.isArray(values) ? values : []).map(function(value, index) {
      var item = isObject(value) ? value : {};
      var color = String(item.color || item.colorHex || "").toUpperCase();
      var frequency = String(item.frequency || "one-time");

      return {
        id: String(item.id || "personal-date-" + index),
        label: String(item.label || item.title || "").slice(0, 80),
        date: /^\d{4}-\d{2}-\d{2}$/.test(String(item.date || ""))
          ? String(item.date)
          : "",
        color: colours.indexOf(color) !== -1
          ? color
          : colours[5] || colours[0] || "#3163A6",
        frequency: frequencies.indexOf(frequency) !== -1
          ? frequency
          : "one-time"
      };
    }).filter(function(item) {
      return item.label && item.date;
    });
  }

  // Personal dates are entered as day + month; the year is the one that places
  // that day inside the 12 months starting at the diary's start month.
  function personalDateIso(dayValue, monthValue, startMonth) {
    var startMatch = /^(\d{4})-(\d{2})$/.exec(String(startMonth || ""));
    var day = Number(dayValue);
    var month = Number(monthValue);
    var year;
    var candidate;

    if (!startMatch || day < 1 || day > 31 || month < 1 || month > 12) {
      return "";
    }

    year = Number(startMatch[1]);
    if (month < Number(startMatch[2])) {
      year += 1;
    }
    candidate = new Date(Date.UTC(year, month - 1, day));

    if (
      candidate.getUTCFullYear() !== year ||
      candidate.getUTCMonth() !== month - 1 ||
      candidate.getUTCDate() !== day
    ) {
      return "";
    }

    return [
      candidate.getUTCFullYear(),
      String(candidate.getUTCMonth() + 1).padStart(2, "0"),
      String(candidate.getUTCDate()).padStart(2, "0")
    ].join("-");
  }

  // Mirrors the renderers: the diary prints from the first day of the start
  // month through the last day of its final month.
  function personalDateRange(selection) {
    var match = /^(\d{4})-(\d{2})$/.exec(String(selection && selection.startMonth || ""));
    var months = Number(selection && selection.documentLengthMonths) || 12;
    var end;

    if (!match) {
      return null;
    }
    end = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1 + months, 0));
    return {
      start: match[1] + "-" + match[2] + "-01",
      end: [
        end.getUTCFullYear(),
        String(end.getUTCMonth() + 1).padStart(2, "0"),
        String(end.getUTCDate()).padStart(2, "0")
      ].join("-")
    };
  }

  // One-time dates print only inside the range; weekly/monthly dates repeat
  // forward from their origin, so they print unless the origin is after it.
  function isPersonalDateInRange(item, selection) {
    var range = personalDateRange(selection);
    var date = String(item && item.date || "");

    if (!range || !/^\d{4}-\d{2}-\d{2}$/.test(date)) {
      return false;
    }
    if (item.frequency === "weekly" || item.frequency === "monthly") {
      return date <= range.end;
    }
    return date >= range.start && date <= range.end;
  }

  // Re-derive, with the entry rule, only the dates the new range would not
  // print. In-range dates and dates the rule cannot place (29 February in a
  // non-leap year) are returned unchanged.
  function rebasePersonalDates(values, selection) {
    return (Array.isArray(values) ? values : []).map(function(item) {
      var match = /^\d{4}-(\d{2})-(\d{2})$/.exec(String(item && item.date || ""));
      var candidate;

      if (!match || isPersonalDateInRange(item, selection)) {
        return clone(item);
      }
      candidate = Object.assign(clone(item), {
        date: personalDateIso(match[2], match[1], selection && selection.startMonth)
      });
      return candidate.date && isPersonalDateInRange(candidate, selection)
        ? candidate
        : clone(item);
    });
  }

  function normalizeFeatures(input) {
    var source = isObject(input) ? input : {};
    var controls = contract && contract.controls ? contract.controls : {};
    var country = isObject(source.countryHolidays) ? source.countryHolidays : {};
    var religious = isObject(source.religiousHolidays) ? source.religiousHolidays : {};
    var moon = isObject(source.moonPhases) ? source.moonPhases : {};
    var offsets = controls.moonTimezoneOffsets || [];
    var offset = Number(moon.timezoneOffset);

    return {
      birthdays: Array.isArray(source.birthdays) ? clone(source.birthdays) : [],
      events: Array.isArray(source.events) ? clone(source.events) : [],
      activities: Array.isArray(source.activities) ? clone(source.activities) : [],
      holidays: Array.isArray(source.holidays) ? clone(source.holidays) : [],
      countryHolidays: {
        enabled: Boolean(country.enabled),
        groups: normalizeStringList(country.groups, controls.countryHolidayGroups)
      },
      religiousHolidays: {
        enabled: Boolean(religious.enabled),
        groups: normalizeStringList(religious.groups, controls.religiousHolidayGroups)
      },
      personalDates: normalizePersonalDates(source.personalDates),
      moonPhases: {
        enabled: Boolean(moon.enabled),
        timezoneOffset: offsets.indexOf(offset) !== -1 ? offset : defaultMoonTimezoneOffset()
      }
    };
  }

  function normalizeState(input) {
    var base = merge(createDefaultState(), input || {});
    var route;
    var requestedPhase;
    var phaseScreen;
    var removedUndatedRefillPath;
    var removedCoverOnlyPath;
    base.schemaVersion = SCHEMA_VERSION;
    base.contractVersion = contract && contract.version ? contract.version : base.contractVersion;
    base.journey.productType = normalizeProductType(base.journey.productType);
    base.journey.lifestyle = LIFESTYLES.indexOf(base.journey.lifestyle) !== -1
      ? base.journey.lifestyle
      : "classic";
    removedUndatedRefillPath = base.journey.productType === "refill"
      && base.journey.refillType === "undated";
    removedCoverOnlyPath = base.journey.productType !== "clipbook"
      && base.journey.refillType === "none";
    base.journey.refillType = base.journey.productType === "refill"
      ? "dated"
      : base.journey.refillType === "undated"
        ? "undated"
        : base.journey.refillType === "none" && base.journey.productType === "clipbook" ? "none" : "dated";
    route = getRoute(base);
    if (removedUndatedRefillPath) {
      // An obsolete Undated Refill save cannot silently become a Dated Review.
      // Keep compatible choices/text, but require the Size/Layout step again.
      base.screen = route[0];
    } else if (!input || !own(input, "screen") || route.indexOf(base.screen) === -1) {
      requestedPhase = input && own(input, "step") && STEPS.indexOf(input.step) !== -1
        ? input.step
        : null;
      phaseScreen = requestedPhase
        ? route.filter(function(screen) { return getScreenStep(base, screen) === requestedPhase; })[0]
        : null;
      base.screen = phaseScreen || route[0];
    }
    if (removedCoverOnlyPath && route.indexOf(base.screen) > route.indexOf("refill-type")) {
      // Cover only exists for the Clipbook. A Planner or Refill save carrying it
      // must choose its refill again instead of landing on an unchosen Dated step.
      base.screen = base.journey.productType === "planner" ? "refill-type" : route[0];
    }
    base.step = getScreenStep(base, base.screen);
    base.selection = normalizeSelection(
      base.selection,
      base.journey.refillType,
      base.journey.productType
    );
    if (datedLayoutError(base)
      && ["planner-details", "personal-dates", "review"].indexOf(base.screen) !== -1) {
      // Preserve an obsolete saved Daily design for the customer to revise;
      // never turn it into a different purchasable layout behind their back.
      base.screen = "dated-layout";
      base.step = getScreenStep(base, base.screen);
    }
    if (contract && contract.resolveFirstPageBackground) {
      base.firstPage.backgroundColor = contract.resolveFirstPageBackground(base.selection);
    }
    base.firstPage = normalizeFirstPage(base.firstPage, base.selection);
    base.cover = coverContract && coverContract.normalizeCover
      ? coverContract.normalizeCover(base.cover)
      : base.cover;
    base.features = normalizeFeatures(base.features);
    return base;
  }

  // English when the store offers it (the UK), else the store's first language.
  function defaultLanguage(languages) {
    return languages.indexOf("en") !== -1 || !languages.length ? "en" : languages[0];
  }

  function createInitialState(input) {
    return normalizeState(input);
  }

  function resetPreview(state) {
    state.preview = {
      status: "idle",
      requestKey: null,
      pages: state.preview && state.preview.pages ? state.preview.pages : [],
      error: null
    };
  }

  function reduce(stateInput, action) {
    var state = normalizeState(stateInput);
    var next = clone(state);
    var payload = action && action.payload;

    switch (action && action.type) {
      case "NAVIGATE_SCREEN":
        if (getRoute(next).indexOf(payload) !== -1) {
          next.screen = payload;
        }
        break;
      case "NAVIGATE_STEP":
        if (STEPS.indexOf(payload) !== -1) {
          var targetScreen = getRoute(next).filter(function(screen) {
            return getScreenStep(next, screen) === payload;
          })[0];
          if (targetScreen) {
            next.screen = targetScreen;
          }
        }
        break;
      case "SET_PRODUCT_TYPE":
        if (next.journey.productType !== normalizeProductType(payload)) {
          next.cover.background = null;
        }
        next.journey.productType = normalizeProductType(payload);
        if (next.journey.refillType === "none") {
          next.journey.refillType = "dated";
        }
        next.screen = getRoute(next)[0];
        break;
      case "SET_REFILL_TYPE":
        next.journey.refillType = payload === "undated" || payload === "none" ? payload : "dated";
        break;
      case "SET_UNDATED_FILL":
        next.journey.undatedFill = String(payload || "");
        break;
      case "SET_SELECTION":
        next.selection = merge(next.selection, payload || {});
        if (
          action.meta && action.meta.requireDatedLayoutConfirmation === true
          && next.journey.productType === "planner"
          && next.journey.refillType === "dated"
          && state.selection.engine === "modern"
        ) {
          next.screen = "dated-layout";
        }
        break;
      case "SET_FIRST_PAGE":
        next.firstPage = merge(next.firstPage, payload || {});
        break;
      case "SET_FEATURES":
        next.features = merge(next.features, payload || {});
        break;
      case "SET_COVER":
        next.cover = merge(next.cover, payload || {});
        break;
      case "SET_COVER_SIZE":
        var requestedCoverSize = next.journey.productType === "planner"
          ? "a5"
          : payload === "personal" ? "personal" : "a5";
        if (next.selection.size !== requestedCoverSize) {
          next.cover.background = null;
        }
        next.selection.size = requestedCoverSize;
        break;
      case "PREVIEW_REQUESTED":
        next.preview = {
          status: "loading",
          requestKey: payload && payload.requestKey ? payload.requestKey : null,
          pages: next.preview.pages || [],
          error: null
        };
        break;
      case "PREVIEW_SUCCEEDED":
        if (payload && next.preview.requestKey && payload.requestKey === next.preview.requestKey) {
          next.preview = {
            status: "ready",
            requestKey: payload.requestKey,
            pages: payload.pages ? clone(payload.pages) : [],
            error: null
          };
        }
        break;
      case "PREVIEW_FAILED":
        if (payload && next.preview.requestKey && payload.requestKey === next.preview.requestKey) {
          next.preview = {
            status: "error",
            requestKey: payload.requestKey,
            pages: next.preview.pages || [],
            error: payload.error ? String(payload.error) : dyofT("state.preview.failed", "Preview failed")
          };
        }
        break;
      case "SAVE_STATUS":
        next.save = merge(next.save, payload || {});
        break;
      case "HYDRATE_SNAPSHOT":
        return hydrateSnapshot(payload);
      case "RESET":
        return createInitialState(payload);
      default:
        if (action && /^COVER_/.test(action.type) && coverContract && coverContract.applyAction) {
          next.cover = coverContract.applyAction(next.cover, action);
          break;
        }
        return next;
    }

    next = normalizeState(next);
    if (next.selection.startMonth !== state.selection.startMonth
      || next.selection.documentLengthMonths !== state.selection.documentLengthMonths) {
      // A new diary range must not silently drop dates entered by day and month.
      next.features.personalDates = rebasePersonalDates(next.features.personalDates, next.selection);
    }

    if (action && (CONFIG_ACTIONS[action.type] || /^COVER_/.test(action.type))) {
      next.revision = state.revision + 1;
      resetPreview(next);
    }

    return next;
  }

  function createStore(initialState) {
    var state = createInitialState(initialState);
    var listeners = [];

    function getState() {
      return clone(state);
    }

    function dispatch(action) {
      var previous = state;
      state = reduce(state, action || {});
      listeners.slice().forEach(function(listener) {
        listener(getState(), clone(previous), action || {});
      });
      return getState();
    }

    function subscribe(listener) {
      if (typeof listener !== "function") {
        return function() {};
      }
      listeners.push(listener);
      return function() {
        listeners = listeners.filter(function(candidate) {
          return candidate !== listener;
        });
      };
    }

    return {
      getState: getState,
      dispatch: dispatch,
      subscribe: subscribe
    };
  }

  function getSnapshot(stateInput) {
    var state = normalizeState(stateInput);
    return {
      schemaVersion: SCHEMA_VERSION,
      contractVersion: state.contractVersion,
      revision: state.revision,
      step: state.step,
      screen: state.screen,
      journey: clone(state.journey),
      selection: clone(state.selection),
      firstPage: clone(state.firstPage),
      cover: clone(state.cover),
      features: clone(state.features)
    };
  }

  function serializeSnapshot(state) {
    return JSON.stringify(getSnapshot(state));
  }

  function migrateSnapshot(snapshotInput) {
    var snapshot = clone(snapshotInput || {});
    var version = Number(snapshot.schemaVersion || 1);

    if (version > SCHEMA_VERSION || version < 1) {
      throw new Error(dyofT("state.restore.unsupported_schema", "Unsupported DYOF snapshot schema version."));
    }

    if (version < 3) {
      snapshot.cover = coverContract && coverContract.normalizeCover
        ? coverContract.normalizeCover(snapshot.cover)
        : snapshot.cover || {};
      snapshot.schemaVersion = 3;
    }

    return snapshot;
  }

  function hydrateSnapshot(snapshotInput) {
    var state;
    var snapshot = typeof snapshotInput === "string"
      ? JSON.parse(snapshotInput)
      : clone(snapshotInput || {});
    snapshot = migrateSnapshot(snapshot);
    delete snapshot.preview;
    delete snapshot.save;
    state = normalizeState(snapshot);
    // Saves made after a start-month change may hold dates their range never printed.
    state.features.personalDates = rebasePersonalDates(state.features.personalDates, state.selection);
    return state;
  }

  function getOrderIntent(stateInput) {
    var state = normalizeState(stateInput);
    var layoutError = datedLayoutError(state);
    if (layoutError) {
      throw new Error(layoutError);
    }
    return {
      schemaVersion: SCHEMA_VERSION,
      contractVersion: state.contractVersion,
      journey: clone(state.journey),
      selection: clone(state.selection),
      firstPage: clone(state.firstPage),
      cover: state.journey.productType === "refill"
        ? undefined
        : coverContract && coverContract.projectOrderCover
          ? coverContract.projectOrderCover(state.cover)
          : clone(state.cover),
      features: clone(state.features)
    };
  }

  function getPreviewRequest(stateInput, pageRequest) {
    var state = normalizeState(stateInput);
    var selection = state.selection;
    var features;
    var selectedHolidays;

    if (state.journey.refillType !== "dated" || datedLayoutError(state)) {
      return null;
    }

    features = clone(state.features);
    selectedHolidays = []
      .concat(
        features.countryHolidays.enabled
          ? features.countryHolidays.groups
          : []
      )
      .concat(
        features.religiousHolidays.enabled
          ? features.religiousHolidays.groups
          : []
      );
    features.events = features.events.concat(features.personalDates.map(function(item) {
      return Object.assign({}, item, { dyofPersonalDate: true });
    }));
    features.holidays = features.holidays.concat(selectedHolidays).filter(function(value, index, values) {
      return typeof value !== "string" || values.indexOf(value) === index;
    });
    delete features.countryHolidays;
    delete features.religiousHolidays;
    delete features.personalDates;

    if (selection.engine === "legacy") {
      return {
        engine: "legacy",
        renderMode: "preview",
        version: state.contractVersion,
        selection: {
          engine: "legacy",
          style: selection.style,
          size: selection.size,
          layout: selection.layout,
          lineStyle: selection.lineStyle,
          calendar: selection.calendar,
          notes: selection.notes,
          appointmentTimes: selection.appointmentTimes,
          language: selection.language,
          startMonth: selection.startMonth,
          startDay: selection.startDay,
          documentLengthMonths: selection.documentLengthMonths,
          firstPage: clone(state.firstPage)
        },
        features: features,
        pageRequest: {
          original: pageRequest || { requestedPages: [1, 2] }
        }
      };
    }

    if (selection.engine !== "modern") {
      return null;
    }

    return {
      engine: "modern",
      renderMode: "preview",
      version: state.contractVersion,
      selection: {
        engine: "modern",
        language: selection.language,
        variant: selection.variant,
        fallbackVariant: selection.fallbackVariant,
        style: selection.style,
        colourMode: selection.colourMode,
        singleColour: selection.singleColour,
        paperColour: selection.paperColour,
        datePosition: selection.datePosition,
        headerTheme: selection.headerTheme,
        size: selection.size,
        startMonth: selection.startMonth,
        startDay: selection.startDay,
        documentLengthMonths: selection.documentLengthMonths,
        firstPage: clone(state.firstPage),
        cover: clone(state.cover)
      },
      features: features,
      pageRequest: {
        original: pageRequest || { type: "week", index: 1 }
      }
    };
  }

  function validateHolidaySelection(stateInput, messages) {
    var state = normalizeState(stateInput);
    var errors = [];
    messages = messages || {};
    if (state.journey.refillType === "dated") {
      if (state.features.countryHolidays.enabled && !state.features.countryHolidays.groups.length) {
        errors.push(messages.countryHolidaysRequired || dyofT("state.validation.country_holidays", "Choose at least one country, or switch off Country Holidays to continue."));
      }
      if (state.features.religiousHolidays.enabled && !state.features.religiousHolidays.groups.length) {
        errors.push(messages.religiousHolidaysRequired || dyofT("state.validation.religious_holidays", "Choose at least one religion, or switch off Religious Holidays to continue."));
      }
    }
    return { valid: errors.length === 0, errors: errors, message: errors[0] || "" };
  }

  // The editor supplies its known upload pixels as messages.coverAssets; without
  // them the photo-resolution rules are left to the editor and the server.
  function coverPrintResolution(state, messages, placements) {
    return messages && messages.coverAssets
      ? {
          size: state.selection.size,
          productType: state.journey.productType,
          assets: messages.coverAssets,
          placements: placements
        }
      : null;
  }

  function validateState(stateInput, messages) {
    var state = normalizeState(stateInput);
    var errors = [];
    var warnings = [];
    var fill;
    var purchase;
    var coverValidation;

    if (datedLayoutError(state)) {
      errors.push(datedLayoutError(state));
    }
    errors = errors.concat(validateHolidaySelection(state, messages).errors);

    if (state.journey.productType === "clipbook" || state.journey.productType === "planner") {
      coverValidation = coverContract && coverContract.validateCover
        ? coverContract.validateCover(state.cover, {
            required: true,
            printResolution: coverPrintResolution(state, messages)
          })
        : { errors: [], warnings: [] };
      errors = errors.concat(coverValidation.errors || []);
      warnings = warnings.concat(coverValidation.warnings || []);
    }

    // Saved or re-styled text the print font cannot draw blocks the order
    // until the customer changes it; new typing is cleaned at the input.
    if (printableText && printableText.findIssues) {
      errors = errors.concat(printableText.findIssues(state).map(function(issue) {
        return issue.message;
      }));
    }

    if (state.journey.refillType === "undated") {
      fill = contract && contract.getUndatedFill
        ? contract.getUndatedFill(state.journey.undatedFill)
        : null;
      if (!fill) {
        errors.push(dyofT("state.validation.undated_invalid", "Choose a valid Undated refill."));
      } else if (fill.status !== "ready") {
        errors.push(dyofT("state.validation.fill_waiting", "{fill} is waiting for its product/PDF asset.", { fill: fill.label }));
      } else if (Array.isArray(fill.sizes) && fill.sizes.indexOf(state.selection.size) === -1) {
        errors.push(dyofT("state.validation.fill_size", "{fill} is not available in {size}.", { fill: fill.label, size: state.selection.size.toUpperCase() }));
      } else if (contract && contract.getUndatedPurchase) {
        // Each size sells its own product; a size without one is never
        // bought as the A5 fill. Preview-only fills are shown, not sold.
        purchase = contract.getUndatedPurchase(state.journey.undatedFill, state.selection.size, state.journey.productType);
        if (purchase.status === "preview-only") {
          errors.push(dyofT("state.validation.fill_preview_only", "{fill} in {size} is a preview for checking only. It can't be ordered yet.", { fill: fill.label, size: state.selection.size.toUpperCase() }));
        } else if (purchase.status !== "ready") {
          errors.push(dyofT("state.validation.fill_size", "{fill} is not available in {size}.", { fill: fill.label, size: state.selection.size.toUpperCase() }));
        }
      }
    }

    if (state.selection.engine === "legacy") {
      warnings.push(dyofT("state.validation.legacy_renderer", "This style will use the retained legacy renderer."));
    }

    return {
      valid: errors.length === 0,
      errors: errors,
      warnings: warnings
    };
  }

  function canAdvanceScreen(stateInput, screenInput, messages) {
    var state = normalizeState(stateInput);
    var screen = screenInput || state.screen;
    var coverValidation;
    var holidays;

    if (datedLayoutError(state)
      && ["dated-layout", "planner-details", "personal-dates", "review"].indexOf(screen) !== -1) {
      return { valid: false, message: datedLayoutError(state) };
    }

    if (["planner-details", "personal-dates", "review"].indexOf(screen) !== -1) {
      holidays = validateHolidaySelection(state, messages);
      if (!holidays.valid) {
        return { valid: false, message: holidays.message };
      }
    }

    if (screen === "cover-selection") {
      // Only the background is edited here; later photos are checked on their own screens.
      coverValidation = coverContract && coverContract.validateCover
        ? coverContract.validateCover(state.cover, {
            required: true,
            printResolution: coverPrintResolution(state, messages, ["background"])
          })
        : { valid: Boolean(state.cover && state.cover.background) };
      var resolutionStop = (coverValidation.printResolution || []).filter(function(entry) {
        return entry.status === "stop";
      })[0];
      return {
        valid: coverValidation.valid,
        message: coverValidation.valid
          ? ""
          : resolutionStop ? resolutionStop.message : dyofT("state.validation.cover_required", "Choose or upload a cover design before continuing.")
      };
    }

    if (screen === "front-cover" || screen === "back-cover") {
      coverValidation = coverContract && coverContract.validateCover
        ? coverContract.validateCover(state.cover, {
            required: true,
            printResolution: coverPrintResolution(
              state,
              messages,
              screen === "front-cover" ? ["background", "front"] : ["background", "front", "back"]
            )
          })
        : { valid: true, errors: [] };
      // Restored cover text the print font cannot draw stops here too, like
      // photo stops (the back cover also rechecks the front).
      var coverSides = screen === "front-cover" ? ["cover:front:"] : ["cover:front:", "cover:back:"];
      var unprintable = printableText && printableText.findIssues
        ? printableText.findIssues(state).filter(function(issue) {
            return coverSides.some(function(prefix) { return issue.key.indexOf(prefix) === 0; });
          })[0]
        : null;
      return {
        valid: coverValidation.valid && !unprintable,
        message: !coverValidation.valid
          ? (coverValidation.errors[0] || dyofT("state.validation.cover_warnings", "Review the cover warnings before continuing."))
          : unprintable ? unprintable.message : ""
      };
    }

    return { valid: true, message: "" };
  }

  return {
    SCHEMA_VERSION: SCHEMA_VERSION,
    STEPS: STEPS.slice(),
    PRODUCT_TYPES: PRODUCT_TYPES.slice(),
    LIFESTYLES: LIFESTYLES.slice(),
    SCREEN_DEFINITIONS: clone(SCREEN_DEFINITIONS),
    DEPENDENCY_RESET_MATRIX: clone(DEPENDENCY_RESET_MATRIX),
    createInitialState: createInitialState,
    createStore: createStore,
    reduce: reduce,
    getSnapshot: getSnapshot,
    serializeSnapshot: serializeSnapshot,
    hydrateSnapshot: hydrateSnapshot,
    migrateSnapshot: migrateSnapshot,
    getOrderIntent: getOrderIntent,
    getRoute: getRoute,
    getScreenPhase: getScreenPhase,
    getScreenStep: getScreenStep,
    getStepDescriptors: getStepDescriptors,
    getPreviewDescriptor: getPreviewDescriptor,
    getPreviewRequest: getPreviewRequest,
    personalDateIso: personalDateIso,
    isPersonalDateInRange: isPersonalDateInRange,
    rebasePersonalDates: rebasePersonalDates,
    validateHolidaySelection: validateHolidaySelection,
    validateState: validateState,
    canAdvanceScreen: canAdvanceScreen
  };
});
